<div class="container">
    <h3 class="title">{{ "designer.actionBtnCont.details.selectcolor" | translate }}</h3>

    <div class="customiseColorPicker">
        <div
            *ngFor="let color of colorsPicker"
            class="color-option"
            [ngClass]="{
                selected: selectedColor === color.value,
                'active-tour': isStepTourActive
            }"
            [style.background-color]="color.value"
            (click)="!isStepTourActive && changeColor(color.value)"
        ></div>
    </div>
</div>
